import { method } from "lodash";

const p5Prefix = "/api/v1/p5";

const p5Type = "p5BeatingBox";

const p5URIS = {
  allPlayers: {
    path:(name,page)=>`/players?name=${name}&page=${page}`,
    method: "GET"
  },
  playerInfo:{
    path:(id)=>{return `/player/${id}`},
    method:"GET",
 },
 statusInfo:{
  path:"/storage/status",
  method:"GET",
 },
 leaderboard:{
  path:"/leaderboard",
  method:"GET"
 }
}

export { p5Prefix, p5URIS, p5Type }
